import { triggerEvent } from "../../services/helpers/trigger-event";

const hasSelected = (tags, reset) => {
  return tags.some(tag => tag.checked && tag !== reset);
};

const updateOrder = (tags) => {
  
  let counter = 0;
  let unchecked = [];
  tags.forEach(tag => {
    if (tag.checked) tag.setAttribute('data-order', counter++);
    else unchecked.push(tag);
  });
  unchecked.forEach(tag => {
    tag.setAttribute('data-order', counter++);
  });
}

const initForm = (form) => {

  let tags = Array.from(form.elements['tags[]']);
  let reset = form.querySelector("[data-filters-reset]");

  let doubleTags = Array.from(form.querySelectorAll('input.double'));

  tags.forEach(tag => {
    tag.addEventListener('change', (e) => {
      form.removeAttribute('data-origin-order');
      if (tag === reset) {
        if (e.isTrusted) form.reset();
      } else {
        if (!hasSelected(tags, reset)) form.reset();
        else {
          if (reset.checked) {
            reset.checked = false;
            triggerEvent(reset, "change");
          }
        }
      }
      updateOrder(doubleTags);
    })
  });

  form.addEventListener('reset', (e) => {
    setTimeout(() => {
      form.setAttribute('data-origin-order', '');
    }, 0)
  });
  
};

const init = () => {
  let mainForm = document.getElementById("tags-filter");
  if (mainForm) initForm(mainForm);
}

export { init, initForm };